import { getRandomAlphaNumericString } from "../../../utility/Utility";

export default class Template3 {
  static getData() {
    return {
      metaData: null,
      scripts: null,
      hash: getRandomAlphaNumericString(),
      designElements: [
        {
          type: "Text",
          value:
            "INFORM CANDIDATES THEY ARE STILL BEING CONSIDERED",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "bold",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 10,
            marginBottom: 16,
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "center",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "Date",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 10,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "Address",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 0,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "Dear",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 26,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "All of the completed candidate files for the position of ________________ at the University of Wisconsin-Stevens Point have been reviewed by the search and screen committee.  Because of the number of well-qualified applicants, screening to identify those who are most highly qualified has been difficult.",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 6,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "I am pleased to tell you that you are one of the candidates still actively being considered for the position.  At this time, we wish to inform you that [PROCEDURE AND RATIONALE FOR NEXT STEP(S):  for example, finalists will be identified in the next ____ weeks; or we will be contacting you to schedule an interview; or the position is on hold because of uncertainty of funding, etc.].",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 0,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "We appreciate your interest in the position and will keep you informed regarding the status of your application.",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 0,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "Sincerely,",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 18,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "NAME OF CHAIR OF SEARCH & SCREEN COMMITTEE",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 16,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 20,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "Enclosure",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 0,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        }
      ],
    };
  }
}
